import { render } from './AppRender';

const ROOT_ELEMENT_ID = 'outdated-browser-info-root';

const rootElement = document.getElementById(ROOT_ELEMENT_ID);

if (rootElement) {
  render(rootElement);
}
